<template>
	<router-link
		data-component="notification-preview"
		:to="getLink"
		:data-is-read="getIsRead"
	>
		<h3 data-element="notification-preview-title">
			<span
				v-if="!getIsRead"
				data-element="notification-preview-unread-mark"
			/>
			{{ getTitle }}
		</h3>
		<p data-element="notification-preview-brief">
			{{ getExcerpt }}
		</p>
		<div data-element="notification-preview-bottom-row">
			<span data-element="notification-preview-date">{{ getDate }}</span>
			<span
				data-element="notification-preview-read-more-btn"
				:data-is-read="getIsRead"
			>
				Read more >
			</span>
		</div>
	</router-link>
</template>

<script>

	import dayjs from 'dayjs';

	export default {
		components: {
		},
		props: {
			notification: {
				type: Object,
				required: true
			},
			className: {
				type: String,
				default: undefined
			}
		},
		computed: {
			getTitle () {
				if (this.notification) {
					return this.notification.title;
				}
				return null;
			},
			getExcerpt () {
				if (this.notification) {
					return this.notification.excerpt;
				}
				return null;
			},
			getLink () {
				if (this.notification) {
					return `/notifications/${this.notification.id}`;
				}
				return null;
			},
			getIsRead () {
				return !!this.notification?.isRead;
			},
			getDate () {
				if (this.notification) {
					return dayjs(this.notification.publishedAt).format('DD/MM/YYYY HH:mm');
				}
				return null;
			}
		}
	};

</script>

<style lang="scss" scoped>

	[data-component='notification-preview'] {
		position: relative;
		width: 100%;
		display: grid;
		gap: 6px;
		padding: 16px 24px 16px 16px;
		border-radius: 5px;
		border: 2px solid $c-gray-l;
		background-color: $c-white-l;
		text-decoration: none;

		&[data-is-read='true'] {
			background-color: $c-gray-l;
		}
	}

	[data-element='notification-preview-title'] {
		color: $c-darkest-navy;
		font-size: 18px;
		line-height: 24px;
		font-weight: 500;
		text-transform: capitalize;

		@media (min-width: 768px) {
			font-size: 22px;
			line-height: 28px;
		}
	}

	[data-element='notification-preview-unread-mark'] {
		display: inline-flex;
		width: 12px;
		height: 12px;
		background-color: $c-red-l;
		border-radius: 50%;
		margin-right: 4px;
		margin-bottom: 1px;
	}

	[data-element='notification-preview-brief'] {
		font-size: 16px;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	[data-element='notification-preview-bottom-row'] {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	[data-element='notification-preview-date'] {
		font-size: 14px;
		color: $c-gray-d3;
	}

	[data-element='notification-preview-read-more-btn'] {
		display: inline-flex;
		font-weight: 700;
		padding: 4px 6px;
		border-radius: 4px;
		color: $c-dark-navy;
		transition: background-color 0.2s ease;

		[data-component='notification-preview']:hover & {
			background-color: $c-gray-l;
		}

		&[data-is-read='true'] {
			[data-component='notification-preview']:hover & {
				background-color: $c-light-navy;
			}
		}
	}

</style>
